/**
 * sentryProvider — @sentry/react adapter for the MonitoringProvider contract.
 *
 * Kept in its own file so the Sentry SDK is only imported here. Swapping to
 * a different provider means adding a new file like this one and changing a
 * single `initMonitoring()` call in `main.tsx`.
 */

import * as Sentry from '@sentry/react';
import type { MonitoringProvider } from './monitoring';

export const sentryProvider: MonitoringProvider = {
  captureException(error, context) {
    Sentry.withScope((scope) => {
      if (context) {
        scope.setExtras(context as Record<string, unknown>);
      }
      Sentry.captureException(error);
    });
  },

  captureMessage(message, level = 'info') {
    Sentry.captureMessage(message, level);
  },

  setUser(user) {
    // Sentry accepts null to clear the user identity.
    Sentry.setUser(user);
  },
};
